import React from 'react';
import {Link} from "react-router-dom";
import Typed from "react-typed";


const BreadcrumbOne = ({ title , rootUrl , parentUrl, currentUrl,Typed1,Typed2,Typed3}) => {
    return (
        <div className="breadcrumb-area breadcarumb-style-1 ptb--120">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="breadcrumb-inner text-center">
                        
                            <h1 className="title HighTitles h2" dangerouslySetInnerHTML={{__html: title}}></h1>
                            <Typed className="title HighTitles h2"
                                            strings={[Typed1, Typed2, Typed3,]}
                                            typeSpeed={80}
                                            backSpeed={3}
                                            backDelay={800}
                                            loop
                                        />
                            <ul className="page-list">
                                <li className="rn-breadcrumb-item"><Link to={`${rootUrl}`} dangerouslySetInnerHTML={{__html: parentUrl}}></Link></li>
                                <li className="rn-breadcrumb-item active" dangerouslySetInnerHTML={{__html: currentUrl}}></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BreadcrumbOne;